/**
 * Copia `testo` negli appunti, con fallback (FE-056).
 *
 * `navigator.clipboard` è disponibile SOLO in contesto sicuro (HTTPS) e non in
 * tutti i webview mobile: su http o in certe app in-app il bottone "Copia"
 * fallirebbe. Qui si tenta la via moderna e, se assente o negata, si ripiega
 * su una textarea temporanea + `document.execCommand('copy')` (deprecato ma
 * ampiamente supportato, ed è l'unico modo in contesto non-sicuro).
 *
 * Ritorna `true` se la copia è riuscita, `false` altrimenti.
 */
export async function copiaTesto(testo) {
  if (navigator.clipboard && navigator.clipboard.writeText) {
    try {
      await navigator.clipboard.writeText(testo);
      return true;
    } catch {
      // permesso negato / contesto non idoneo → si prova il fallback sotto
    }
  }
  try {
    const ta = document.createElement('textarea');
    ta.value = testo;
    ta.setAttribute('readonly', '');
    ta.style.position = 'fixed';
    ta.style.top = '-9999px';
    document.body.appendChild(ta);
    ta.select();
    const ok = document.execCommand('copy');
    document.body.removeChild(ta);
    return ok;
  } catch {
    return false;
  }
}
